// extracted by mini-css-extract-plugin
module.exports = {"root":"SectionForLandowners_root__2gVk9"};